import { MeasurementSystem } from '../types/MeasurementSystem';
import { MetricConverter, PerUnitLengthMetricConverter } from './helpers';

const InductanceUnits = ['uH', 'mH', 'H'] as const;
type TInductanceUnit = (typeof InductanceUnits)[number];

class InductanceConverter extends MetricConverter<TInductanceUnit, 'H'> {
    baseUnit = 'H' as const;
    units = InductanceUnits;
}

export const inductanceConverter = new InductanceConverter();

const InductancePerUnitLengthMetricUnits = ['uH/m', 'uH/km', 'mH/m', 'mH/km', 'H/m', 'H/km'] as const;
type TInductancePerUnitLengthMetricUnit = (typeof InductancePerUnitLengthMetricUnits)[number];

const InductancePerUnitLengthImperialUnits = ['uH/ft', 'mH/ft', 'H/ft'] as const;
type TInductancePerUnitLengthImperialUnit = (typeof InductancePerUnitLengthImperialUnits)[number];

export const InductancePerUnitLengthUnits = [
    ...InductancePerUnitLengthMetricUnits,
    ...InductancePerUnitLengthImperialUnits,
] as const;
type TInductancePerUnitLengthUnit = (typeof InductancePerUnitLengthUnits)[number];

type InductancePerUnitLengthUnitForSystem<MSystem extends MeasurementSystem> = MSystem extends MeasurementSystem.METRIC
    ? TInductancePerUnitLengthMetricUnit
    : MSystem extends MeasurementSystem.IMPERIAL
      ? TInductancePerUnitLengthImperialUnit
      : never;

export class InductancePerUnitLengthConverter<MSystem extends MeasurementSystem> extends PerUnitLengthMetricConverter<
    TInductancePerUnitLengthUnit,
    'H/m'
> {
    baseUnit = 'H/m' as const;
    units = InductancePerUnitLengthUnits;
    system: MSystem;

    constructor(measurementSystem: MSystem) {
        super();
        this.system = measurementSystem;
    }

    getDisplayUnits(): InductancePerUnitLengthUnitForSystem<MSystem>[] {
        switch (this.system) {
            case MeasurementSystem.METRIC:
                return [...InductancePerUnitLengthMetricUnits] as InductancePerUnitLengthUnitForSystem<MSystem>[];
            case MeasurementSystem.IMPERIAL:
                return [...InductancePerUnitLengthImperialUnits] as InductancePerUnitLengthUnitForSystem<MSystem>[];
            default:
                throw new Error('Invalid measurement system');
        }
    }
}
